export default "__VITE_ASSET__f91a1720__"